import FlatLayout from 'components/Layout/FlatLayout';

import Achievements from './Achievements';
import BePartnerForm from './BePartner';
import Head from './Head';
import Hero from './Hero';
import MediaArticles from './MediaArticles';
import PartnerCases from './PartnerCases';
import Partners from './Partners';
import Strategies from './Strategies';

const GA_EVENT_CATEGORY = 'lp_commercial';

const CommercialPartners = () => (
  <>
    <Head />
    <FlatLayout.Margin>
      <FlatLayout.Body>
        <Hero gaEventCategory={GA_EVENT_CATEGORY} />
        <Partners className="my-16 md:mb-[120px] md:mt-[104px]" />
        <Achievements />
        <Strategies className="my-16 md:my-[120px]" />
        <PartnerCases />
        <MediaArticles className="my-16 md:my-[120px]" />
        <BePartnerForm gaEventCategory={GA_EVENT_CATEGORY} />
      </FlatLayout.Body>
    </FlatLayout.Margin>
    <FlatLayout.Footer />
  </>
);

export default CommercialPartners;
